// Calls for Update Knowledge (admin console), through the typed hc<AppType>
// client: /admin/knowledge-update. Response types come from the routes.
// Errors become ApiError with the API's Indonesian message, like api.ts.
import type { InferResponseType } from "hono/client";
import { ApiError, errorMessage } from "./api";
import { api } from "./client";

type UpdateRoutes = (typeof api.admin)["knowledge-update"];
type ListRes = InferResponseType<UpdateRoutes["$get"], 200>;
type RunRes = InferResponseType<UpdateRoutes["run"]["$post"], 202>;

export type KnowledgeUpdateView = ListRes;
export type UpdateItem = ListRes["items"][number];
export type UpdateRunStart = RunRes;

export { errorMessage };

interface ResLike {
  ok: boolean;
  status: number;
  json(): Promise<unknown>;
}

async function send<T>(request: () => Promise<ResLike>): Promise<T> {
  let res: ResLike;
  try {
    res = await request();
  } catch {
    throw new ApiError(0, "Tidak dapat terhubung ke server. Periksa koneksi lalu coba lagi.");
  }
  if (res.ok) return (await res.json()) as T;
  let body: Record<string, unknown> | null = null;
  try {
    body = (await res.json()) as Record<string, unknown>;
  } catch {
    // Not JSON.
  }
  const message = typeof body?.error === "string" && body.error.trim() ? body.error : "Terjadi kesalahan. Coba lagi.";
  throw new ApiError(res.status, message, null, null, body);
}

export async function getKnowledgeUpdate(): Promise<KnowledgeUpdateView> {
  return send<ListRes>(() => api.admin["knowledge-update"].$get());
}

/** Starts the update; 409 code "running" or "nothing_new" as ApiError. */
export async function startKnowledgeUpdate(): Promise<UpdateRunStart> {
  return send<RunRes>(() => api.admin["knowledge-update"].run.$post());
}
